<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['factory.no']">
              <a-input :placeholder="language['common.pleaseInput']+language['factory.no']" v-model="queryParam.factoryCode"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['factory.name']" >
              <a-input :placeholder="language['common.pleaseInput']+language['factory.name']" v-model="queryParam.factoryName"></a-input>
            </a-form-item>
          </a-col>
            
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search" >{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px" >{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'factory:add'">{{language['common.insertButton']}}</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('厂区表')" v-has="'factory:export'">{{language['common.exportButton']}}</a-button>
      <!-- <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- 高级查询区域 -->
      <!-- <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query> -->
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu v-has="'factory:batchDelete'" slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete" v-has="'factory:batchDelete'"/>{{language['common.delete']}}</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{language['common.batchAction']}} <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <template slot="address" slot-scope="text, record, index">
          <a-tooltip :title="record.address" placement="topLeft" :disabled="false">
            <span>{{!text?"":(text.length>20?text.substr(0,20)+"...":text)}}</span>
          </a-tooltip>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)" v-has="'factory:edit'">{{language['common.edit']}}</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a  v-has="'factory:detail'" @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="language['common.deleteConfirmInfo']" :okText="language['common.okButton']" :cancelText="language['common.cancel']" @confirm="() => handleDelete(record.id)">
                  <a v-has="'factory:delete'">{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <ep-factory-modal ref="modalForm" @ok="modalFormOk"></ep-factory-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EpFactoryModal from './modules/EpFactoryModal'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'

  export default {
    name: 'EpFactoryList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EpFactoryModal
    },
    data () {
      return {
        description: '厂区表管理页面',
        url: {
          list: "/sys/epFactory/list",
          delete: "/sys/epFactory/delete",
          deleteBatch: "/sys/epFactory/deleteBatch",
          exportXlsUrl: "/sys/epFactory/exportXls",
          importExcelUrl: "/sys/epFactory/importExcel",
          
        },
        dictOptions:{},
        superFieldList:[],
      }
    },
    created() {
    this.getSuperFieldList();
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      columns(){
        if(this.language){
          return  [
          {
            title: this.language['common.serialNumber'],
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:this.language['basedata.country'],
            align:"center",
            width:200,
            sorter: true,
            dataIndex: 'countryName'
          },
          {
            title:this.language['basedata.province'],
            align:"center",
            width:200,
            sorter: true,
            dataIndex: 'provinceName'
          },
          {
            title:this.language['basedata.city'],
            align:"center",
            width:200,
            sorter: true,
            dataIndex: 'cityName'
          },
          {
            title:this.language['factory.no'],
            align:"center",
            sorter: true,
            dataIndex: 'factoryCode',
            width:200,
          },
          {
            title:this.language['factory.name'],
            align:"center",
            sorter: true,
            dataIndex: 'factoryName',
            width:200,
          },
          {
            title:this.language['factory.address'],
            align:"center",
            dataIndex: 'address',
            width:300,
            scopedSlots: {customRender: 'address'},
          },
          {
            title: this.language['common.action'],
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
        }
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'factoryNo',text:'厂区编号',dictCode:''})
        fieldList.push({type:'string',value:'factoryName',text:'厂区名称',dictCode:''})
        fieldList.push({type:'string',value:'regionCode',text:'所属行政区域',dictCode:'ep_region'})
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>